module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.showAddPosModal,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.showAddPosModal = false
      }
    }
  }, [_c('div', {
    staticClass: "notice-box"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$t(_vm.notice)) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": _vm.registerPosUrl
    },
    on: {
      "click": _vm.logoutAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddPosModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))]), _vm._v(" "), _c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success pull-left add-pos-btn' : 'btn btn-success pull-right add-pos-btn',
    attrs: {
      "type": "button",
      "title": _vm.$t('Add Supportive Establishment'),
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddPosModal = true
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Supportive Establishments')))]), _vm._v(" "), _c('g-map-window')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2f5af7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportivePOS.vue
// module id = 322
// module chunks = 1